import React, { useState } from "react";
import { Modal } from "@arcteryx/components-modal";
import { SiteContextProvider } from "@arcteryx/components-contexts";
const OutletFlashSale = ({ isClosable, stateFromHeader: { market, language, country } }) => {
  const [modalIsShown, toggleModal] = useState(true);
  return (
    <SiteContextProvider market={market} country={country} language={language}>
      <Modal modalIsShown={modalIsShown} toggleModal={toggleModal} isClosable={isClosable} iframe>
        <iframe src={`/${country}/${language}/email-notify-me`}></iframe>
      </Modal>
    </SiteContextProvider>
  );
};

export default OutletFlashSale;
